export default class CustomDecimals {
  static roundProperly (value, decimals = 2) {
    value = Number(value).toFixed(10);
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals).toFixed(decimals);
  }
}
